"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Placeholder = exports.DEF_PLACEHOLDER = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const ui_1 = require("@jsonjoy.com/ui");
const context_1 = require("@jsonjoy.com/ui/lib/styles/context");
const MuTxtLogo_1 = tslib_1.__importDefault(require("@jsonjoy.com/ui/lib/icons/svg/MuTxtLogo"));
const context_2 = require("../../context");
const Key_1 = require("@jsonjoy.com/ui/lib/1-inline/Key");
exports.DEF_PLACEHOLDER = (React.createElement("span", { style: { display: 'inline', alignItems: 'center' } },
    "Start writing in your",
    ' ',
    React.createElement(MuTxtLogo_1.default, { style: { margin: '-8px 0 -12px', display: 'inline-block', verticalAlign: 'middle' } }),
    " document",
    !ui_1.isTouch && (React.createElement(React.Fragment, null,
        "\u00A0or press ",
        React.createElement(Key_1.Key, null, "Space"),
        " for commands")),
    "..."));
const placeholderClass = (0, nano_theme_1.rule)({
    pe: 'none',
    us: 'none',
    fz: '16px',
});
const Placeholder = (props) => {
    const { attributes, children } = props;
    const styles = (0, context_1.useStyles)();
    const mutxt = (0, context_2.useMuTxt)();
    if (!children)
        return null;
    if (mutxt.api.block()?.type !== 'p')
        return null;
    if (Object.keys(mutxt.api.marks() ?? {}).length)
        return null;
    return (React.createElement("span", { ...attributes, className: placeholderClass, style: {
            ...attributes.style,
            color: styles.g(0.5),
            opacity: 1,
        } }, children));
};
exports.Placeholder = Placeholder;
